export enum ButtonTypes {
    RedButton = 'btn-red',
    BlueButton = 'btn-blue',
    GreenButton = 'btn-green',
    RedRoundedButton = 'btn-red-rounded',
    BlueRoundedButton = 'btn-blue-rounded',
    GreenRoundedButton = 'btn-green-rounded',
    TextButton = 'border-transparent'
}